<template>
    <div class="table_wrap">
        <div class="c_table_wrap table_search_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">제목</td>
                    <td>
                        <div class="search">
                            <el-input
                                    class="table_s_input"
                                    v-model="searchInput"
                                    size=""
                                    prefix-icon="el-icon-search"
                                    placeholder="검색어를 입력해주세요."
                                    maxLength="40"
                                    @keyup.enter.native="runFilter('su', searchInput)"
                            >
                            </el-input>
                            <el-button type="primary" class="ml10" @click="runFilter('su', searchInput)">
                                검색
                            </el-button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">언어</td>
                    <td>
                        <div>
                            <el-select v-model="filterCountry" placeholder="언어선택" class="table_s_select" @change="runFilter('cid', filterCountry)">
                                <el-option
                                        :label="'전체'"
                                        :value="''"
                                ></el-option>
                                <el-option
                                    v-for="country in languageList"
                                    :key="`country${country.c_idx}`"
                                    :label="country.c_lang_ko"
                                    :value="`${country.c_idx}`"
                                ></el-option>
                            </el-select>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">카테고리</td>
                    <td>
                        <div>
                            <el-select v-model="filterCategory" placeholder="카테고리선택" class="table_s_select" @change="runFilter('ca', filterCategory)"
                                       :disabled="filterCountry === ''">
                                <el-option
                                        :label="'전체'"
                                        :value="''"
                                ></el-option>
                                <el-option
                                    v-for="category in categorys"
                                    :key="`category${category.bc_idx}`"
                                    :label="category.bc_name"
                                    :value="`${category.bc_idx}`"
                                    v-if="category.c_idx === Number(filterCountry)"
                                ></el-option>
                            </el-select>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import boardFilterUtil from "@/components/board/boardFilterUtil"
    import {mapState, mapGetters} from "vuex"
    import languageList from "../../../mixins/languageList";
    const {filterConfig} = boardFilterUtil;
    export default {
        name: "BoardFilterJstFaqLayout",
        mixins: [languageList],
        components: {
        },
        props:{
            filterData: {},
            categorys:{},
            setFilter: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                searchInput: '',
                searchInputOption: 'su',
                searchInputOptions: [
                    {value: 'su', label: '제목'},
                    {value: 'co', label: '내용'}
                ],
                filterCountry: '',
                filterCategory: '',
                filterDate: ['', ''],
            }
        },
        beforeRouterEnter() {},
        created() {
            this.getLanguage();
        },
        mounted() {
            this.setterFilterDataInData();
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            setterFilterDataInData() {
                let classnames = Object.keys(this.filterData);
                classnames.forEach(classname => {
                    let obj = this.filterData[classname];
                    let type = filterConfig[obj.key].type;
                    if(this.hasOwnProperty(classname)) {
                        if(type == 'query') {
                            this[classname] = obj.query;
                        }else if(type === 'between') {
                            this[classname] = [obj.start, obj.end];
                        }else if(type === 'match') {
                            this[classname] = obj.value;
                        }
                        if(this.hasOwnProperty(`${classname}Option`)) {
                            this[`${classname}Option`] = obj.key;
                        }
                    }
                })
            },
            setData(key, value) {
                this[key] = value;
            },
            runFilter(key, value) {
                if(key === 'cid' && value === ''){
                    this.filterCategory = '';
                    this.setFilter('ca', this.filterCategory);
                }
                this.setFilter(key, value)
            }
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>